const text = (value) => `${value || ""}`.trim().toLowerCase();

const STATUS_DEFINITIONS = [
  {
    key: "refunded",
    matches: ["refund", "reversed"],
    terminal: true,
    successful: false,
    labels: { english: "Refunded", arabic: "مسترجع" },
  },
  {
    key: "cancelled",
    matches: ["cancel"],
    terminal: true,
    successful: false,
    labels: { english: "Cancelled", arabic: "ملغي" },
  },
  {
    key: "failed",
    matches: ["fail", "declined", "rejected"],
    terminal: true,
    successful: false,
    labels: { english: "Payment failed", arabic: "فشل الدفع" },
  },
  {
    key: "completed",
    matches: ["complete", "delivered", "closed"],
    terminal: true,
    successful: true,
    labels: { english: "Completed", arabic: "مكتمل" },
  },
  {
    key: "driver_pending",
    matches: ["driver pending", "awaiting driver"],
    terminal: false,
    successful: false,
    labels: { english: "Waiting for a driver", arabic: "بإنتظار السائق" },
  },
  {
    key: "out_for_delivery",
    matches: ["out for delivery", "dispatch", "delivery"],
    terminal: false,
    successful: false,
    labels: { english: "Out for delivery", arabic: "يتم توصيله" },
  },
  {
    key: "ready",
    matches: ["ready", "collect"],
    terminal: false,
    successful: false,
    labels: { english: "Ready", arabic: "جاهز" },
  },
  {
    key: "preparing",
    matches: ["preparing", "open", "in progress"],
    terminal: false,
    successful: false,
    labels: { english: "Preparing", arabic: "يتم تحضيره" },
  },
  {
    key: "received",
    matches: ["received", "accepted", "confirmed"],
    terminal: false,
    successful: false,
    labels: { english: "Accepted", arabic: "تم القبول" },
  },
  {
    key: "new",
    matches: ["new", "pending"],
    terminal: false,
    successful: false,
    labels: { english: "New", arabic: "جديد" },
  },
];

export const normalizeTrackingStatus = (status, options = {}) => {
  const normalized = text(status);
  const definition = STATUS_DEFINITIONS.find((candidate) =>
    candidate.matches.some((match) => normalized.includes(match)),
  );
  const fallback = {
    key: "unknown",
    terminal: false,
    successful: false,
    labels: {
      english: `${status || "Status unavailable"}`,
      arabic: `${status || "الحالة غير متوفرة"}`,
    },
  };
  const result = definition || fallback;
  const labels = { ...result.labels };

  if (result.key === "out_for_delivery" && options.isPickup) {
    labels.english = options.isTable ? "Ready" : "Ready to collect";
    labels.arabic = options.isTable ? "جاهز" : "جاهز للاستلام";
  }

  return { ...result, raw: status || "", labels };
};

export const normalizePaymentStatus = (order = {}) => {
  if (order.payment_complete === true || order.paymentComplete === true)
    return "succeeded";

  const paymentStatus = text(
    order.payment_status || order.paymentStatus || order.payment_state,
  );
  if (["paid", "success", "succeeded", "complete", "completed"].includes(paymentStatus))
    return "succeeded";
  if (["failed", "declined", "cancelled", "canceled", "refunded"].includes(paymentStatus))
    return "failed";
  if (["pending", "processing", "redirected", "created"].includes(paymentStatus))
    return "pending";

  const orderStatus = normalizeTrackingStatus(order.status);
  if (["failed", "cancelled", "refunded"].includes(orderStatus.key))
    return "failed";
  return "pending";
};
